export default __webpack_public_path__ + "static/media/toShow-8-min.1641ba38.jpg";